<template>
  <div class="ml-5 mr-5">
    <div
      v-bind:class="{ errorShake: isErrorShake }"
      class="mt-6"
      style="max-width: 600px; background-color: rgb(240, 240, 240); border: 1px solid rgb(130, 130, 130); border-radius: 5px; padding: 30px; margin: 0 auto; box-shadow: 0 0 10px rgb(150, 150, 150)"
    >
      <a @click="adminPage">Admin Home</a>
      <span class="ml-1 mr-1">></span>
      <a @click="stickersPage">Stickers</a>
      <span class="ml-1 mr-1">></span>

      <a>Edit Sticker</a>

      <h1 class="text-center mb-4">Edit Sticker</h1>
      <div v-if="this.error != ''">
        <v-alert type="error" v-bind="this.error" style="font-weight: bold;">{{this.error}}</v-alert>
      </div>

      <v-form ref="form">
        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="Title"
            required
            :rules="[rules.required]"
            v-model="title"
          ></v-text-field>
        </div>
        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="Description"
            required
            :rules="[rules.required]"
            v-model="description"
          ></v-text-field>
        </div>
        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-select v-model="kind" :items="items" label="Kind"></v-select>
        </div>
        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="Category1"
            v-model="category1"
            type="category1"
          ></v-text-field>
        </div>
        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="Category2"
            v-model="category2"
            type="category2"
          ></v-text-field>
        </div>
        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="Sales"
            required
            :rules="[rules.required]"
            v-model="sales"
            type="sales"
          ></v-text-field>
        </div>
        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="Slug"
            required
            :rules="[rules.required]"
            v-model="slug"
            type="slug"
          ></v-text-field>
        </div>
        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="Thumbnail"
            required
            :rules="[rules.required]"
            v-model="thumbnail"
            type="thumbnail"
          ></v-text-field>
        </div>
        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="Image1"
            required
            :rules="[rules.required]"
            v-model="image1"
            type="image1"
          ></v-text-field>
        </div>
        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="Image2"
            required
            :rules="[rules.required]"
            v-model="image2"
            type="image2"
          ></v-text-field>
        </div>
        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="Image3"
            required
            :rules="[rules.required]"
            v-model="image3"
            type="image3"
          ></v-text-field>
        </div>

        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <div style="display: flex;">
            <span class="mr-2 mt-1">Active:</span>
            <v-checkbox v-model="isActive" style="padding: 5px; margin: 0px;"></v-checkbox>
          </div>
        </div>

        <div style="width: 60%; margin: 0 auto;">
          <v-btn
            class="mb-2"
            style="width: 100%; box-shadow: 0 0 5px rgb(150, 150, 150)"
            height="50"
            color="success"
            @click="updateSticker"
          >Update Sticker</v-btn>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
import AdminService from "@/services/AdminService";

export default {
  data: () => ({
    error: "",
    sticker: null,
    message: "",
    id: null,
    title: "",
    description: "",
    items: ["1 pack", "5 pack", "10 pack"],
    kind: "",
    category1: "",
    category2: "",
    popularity: "",
    slug: "",
    thumbnail: "",
    image1: "",
    image2: "",
    image3: "",
    isActive: false,
    isErrorShake: false,
    rules: {
      required: value => !!value || "Required."
    }
  }),
  async mounted() {
    try {
      const response = await AdminService.admin();
    } catch (error) {
      // Credentials failed. Logout user and instruct them to login
      this.$store.dispatch("setToken", null);
      this.$store.dispatch("setUser", null);
      this.error = error.response.data.error;
    }
    this.sticker = this.$store.state.selectedSticker;
    this.id = this.sticker.id;
    this.title = this.sticker.title;
    this.isActive = this.sticker.isActive;
    this.description = this.sticker.description;
    this.kind = this.sticker.kind;
    this.category1 = this.sticker.category1;
    this.category2 = this.sticker.category2;
    this.sales = this.sticker.sales;
    this.slug = this.sticker.slug;
    this.thumbnail = this.sticker.thumbnail;
    this.image1 = this.sticker.image1;
    this.image2 = this.sticker.image2;
    this.image3 = this.sticker.image3;
  },
  methods: {
    adminPage() {
      this.$router.push("/admin");
    },
    stickersPage() {
      this.$router.push("/adminStickers");
    },
    selectUser(user) {
      this.$store.dispatch("setSelectedUser", user);
    },
    async updateSticker() {
      try {
        const response = await AdminService.updateSticker({
          id: this.id,
          title: this.title,
          isActive: this.isActive,
          description: this.description,
          kind: this.kind,
          category1: this.category1,
          category2: this.category2,
          sales: this.sales,
          slug: this.slug,
          thumbnail: this.thumbnail,
          image1: this.image1,
          image2: this.image2,
          image3: this.image3
        });
        this.$router.push("/adminStickers");
      } catch (error) {
        this.error = error.response.data.error;
        this.isErrorShake = true;
        setTimeout(() => {
          this.isErrorShake = false;
        }, 800);
      }
    }
  }
};
</script>
